import config from "../../../config";

function authHeader() {
  let user = JSON.parse(localStorage.getItem("user"));
  if (user) {
    if (user.key) {
      return { Authorization: "Token  " + user.key };
    } else {
      return {};
    }
  } else {
    return {};
  }
}

const getStatisticsData = async (stagingID) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json", ...authHeader() });
  const req = new Request(`${config.apiGateway.URL}/clinics/staging-groups/${stagingID}/statistics/`, {
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

export const controller = { getStatisticsData };
